import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=740459ee&scoped=true&"
import script from "./addGoods.vue?vue&type=script&lang=js&"
export * from "./addGoods.vue?vue&type=script&lang=js&"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=740459ee&lang=less&scoped=true&"
import style1 from "./addGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740459ee",
  null
  
)

component.options.__file = "addGoods.vue"
export default component.exports